import { Formik } from 'formik';
import pluralize from 'pluralize';
import React, { useRef } from 'react';
import * as Yup from 'yup';
import { Field, FixedSingleSelect, Form } from '~/components';
import BulkActionModal from '~/components/bulk-action/BulkActionModal';
import { useApi, useWorkspace } from '~/contexts';
import OpportunityDetails from './OpportunityDetails';

export default function BulkSetPriority({ ids, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();
  const formRef = useRef();

  return (
    <BulkActionModal
      title="Bulk Set Priority"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() => formRef.current?.submitForm()}
      renderRow={OpportunityDetails}>
      <Formik
        innerRef={formRef}
        initialValues={{ priorityId: null }}
        onSubmit={async (values) => {
          const body = { priorityId: values.priorityId || null };
          return api.www
            .workspaces(workspace.id)
            .opportunities()
            .bulkSetPriority(ids, body)
            .then((r) => r.data);
        }}
        validateOnBlur={false}
        validateOnChange={false}
        validationSchema={Yup.object().shape({
          priorityId: Yup.string().label('Priority').oneOf(['high', 'medium', 'low', '']).nullable(),
        })}>
        {() => (
          <Form>
            <p>
              Set the priority of {ids.length} {pluralize('opportunity', ids.length)} to:
            </p>

            <Form.Control>
              <Field.OpportunityPrioritySelect name="priorityId" placeholder="Priority" component={FixedSingleSelect} />
            </Form.Control>
          </Form>
        )}
      </Formik>
    </BulkActionModal>
  );
}
